import { render, staticRenderFns } from "./SwiftMessageOrderCreateModal.vue?vue&type=template&id=2257b82a"
import script from "./SwiftMessageOrderCreateModal.vue?vue&type=script&lang=js"
export * from "./SwiftMessageOrderCreateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports